<template>
    <rkm-modal
        persistent
        ref="RkmModal"
        title="Encaminhamento"
    >
        <rkm-form ref="RkmForm">
            <rkm-row>
                <rkm-col>
                    <rkm-form-select
                        :options="data.form.centrosCustoEncaminhamento"
                        :validations="validations.centroCustoEncaminhamento"
                        label="Setor de Encaminhamento"
                        show-default-option
                        text-field="setorNome"
                        v-model="model.centroCustoEncaminhamentoId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Cancelar
            </rkm-button>

            <rkm-button
                @click="save"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        validations() {
            return {
                centroCustoEncaminhamento: {required: true},
            }
        },
    },
    created() {
        this.repositories = {
            fila: this.getConectaSusRepository('ambulatorio.fila'),
        }
    },
    data: () => ({
        fila: null,
        model: {
            centroCustoEncaminhamentoId: null,
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(fila) {
            this.reset()

            this.fila = fila

            this.$refs.RkmModal.show()
        },
        reset() {
            this.fila = null
            this.model.centroCustoEncaminhamentoId = null
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (!valid) return

                    this.setLoading()

                    const request = this.camelObjectKeysToSnakeRecursive(this.model)

                    this.repositories.fila.forward(this.fila.id, request)
                        .then(() => {
                            this.showSaveNotification()
                            this.$refs.RkmModal.hide()
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
    },
    mixins: [error, repository, stringCase],
    props: {
        data: {type: Object, required: true},
    },
}
</script>